import { jwtDecode } from 'jwt-decode'

export const checkToken = (token) => {
  if (!token) return false
  const now = Date.now()
  const decoded = jwtDecode(token)
  return (now <= decoded.exp * 1000)
}
